import * as ActionTypes from './actionTypes';

export const setLoading = (isLoading) => ({
    type: ActionTypes.SET_LOADING,
    payload: isLoading
});

export const loading = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.SET_LOADING:
            return action.payload;
        default:
            return state;
    }
};

